import '../MortgageBuyOrDie.css';

import React, { RefObject, useCallback, useState } from 'react';
import { Typography, Badge, useDropdownHover, Dropdown, Tooltip, Modal, Button } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';
import { cnMrtgBuyOrDie } from '../MortgageBuyOrDieModal';

const DROPDOWN_OPENING_DELAY = 250;

const PriceHoverControl = () => {
    const { control } = useDropdownHover({ open: DROPDOWN_OPENING_DELAY });

    return (
        <span
            ref={control as RefObject<HTMLDivElement>}
            className={cnMrtgBuyOrDie('result-price-disclaimer-trigger')}
        >
            <Icon name='information-circle' size='m' color='rgb(172, 182, 195)' />
        </span>
    );
};

export function MortgageBuyOrDieResultCard({
    isProfitable,
    type,
    price,
    time,
    isMobile,
    isOverLimit
}: {
    type: 'mortgage' | 'acc';
    isProfitable: boolean;
    isMobile?: boolean;
    price: string;
    time: string;
    isOverLimit?: boolean;
}) {
    const texts = (() => {
        if (type === 'mortgage') {
            return {
                mainText: 'Взять ипотеку и\u00A0купить квартиру сейчас',
                resultText: 'потратите вместе с\u00A0процентами и\u00A0закроете ипотеку'
            };
        }
        return {
            mainText: 'Арендовать квартиру и\u00A0копить на\u00A0свою',
            resultText: `потратите на\u00A0покупку квартиры, ${isOverLimit ? 'копить придётся' : 'накопите'}`
        };
    })();

    const [ isOpenDisclaimer, setIsOpenDisclaimer ] = useState(false);
    const openDislaimer = useCallback(() => setIsOpenDisclaimer(true));
    const closeDislaimer = useCallback(() => setIsOpenDisclaimer(true));

    return (<div className={cnMrtgBuyOrDie('result', { isProfitable })}>
        <Badge color={isProfitable ? 'success' : 'lightgray'} variant={isProfitable ? 'solid' : 'light'}>
            {isProfitable ? 'выгоднее' : 'дороже'}
        </Badge>
        <Typography bold variant='primary-alone'>{texts.mainText}</Typography>

        <Typography bold variant='h2' onClick={isMobile ? openDislaimer : undefined} className={cnMrtgBuyOrDie('result-price')}>
            {`${isOverLimit ? '>\u00A0' : ''}${price}`}
            {type === 'acc' && ! isMobile && (
                <Dropdown>
                    <PriceHoverControl />
                    <Dropdown.Content positioning='end'>
                        <div style={{ width: isMobile ? 280 : 320 }}>В&nbsp;среднем, недвижимость ежегодно дорожает на&nbsp;5-7%</div>
                    </Dropdown.Content>
                </Dropdown>
            )}
            {type === 'acc' && isMobile && (
                <span className={cnMrtgBuyOrDie('result-price-disclaimer-trigger')}>
                    <Icon name='information-circle' size='m' color='hsla(251, 15%, 50%, 0.5)' />
                </span>
            )}
        </Typography>
        {isOpenDisclaimer && (
            <Modal
                opened
                closable
                onClose={closeDislaimer}
                swipeToClose
            >
                <Modal.Content>
                    <div className={cnMrtgBuyOrDie('result-price-disclaimer')}>В&nbsp;среднем, недвижимость ежегодно дорожает на&nbsp;5-7%</div>
                </Modal.Content>
                <Modal.Actions>
                    <Button variant='secondary' onClick={closeDislaimer}>Свернуть</Button>
                </Modal.Actions>
            </Modal>
        )}
        <Typography variant='primary-alone'>
            {texts.resultText}&nbsp;
            <Typography tag='span' bold>{time}</Typography>
        </Typography>
    </div>);
}
